import { cn } from "@/utils/classes";

/* Prop Types */
interface IndicatorProps {
  color: string;
  className?: string;
  size?: "xs" | "small" | "medium" | "large";
}

/*
 * Indicator component
 */
export const Indicator = ({ color, className, size = "large" }: IndicatorProps) => {
  return (
    <span
      className={cn(`block rounded-full size-4 flex-shrink-0`, className, {
        "size-5": size === "large",
        "size-3": size === "small",
        "size-4": size === "medium",
      })}
      style={{ backgroundColor: color }}
    ></span>
  );
};
